import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FieldSelect } from 'components/form';
import { useLocations } from 'api/hooks';

export default function LocationFilter({ onChange, ...rest }) {
  const { locations, isLoading } = useLocations({});
  const [selectedValue, setSelectedValue] = useState();

  const onSelect = useCallback(
    (option) => {
      setSelectedValue(option);
      onChange(option);
    },
    [onChange],
  );
  return (
    <FieldSelect
      value={selectedValue}
      onChange={(_value, option) => onSelect(option)}
      isLoading={isLoading}
      options={locations ?? []}
      focusColor="indigo"
      searchable
      {...rest}
    />
  );
}

LocationFilter.propTypes = {
  onChange: PropTypes.func,
};
LocationFilter.defaultProps = {
  onChange: _.noop,
};
